var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.375C8.51794 11.375 8.29538 11.4672 8.13128 11.6313C7.96719 11.7954 7.875 12.0179 7.875 12.25C7.875 12.4821 7.96719 12.7046 8.13128 12.8687C8.29538 13.0328 8.51794 13.125 8.75 13.125H15.75C15.9821 13.125 16.2046 13.0328 16.3687 12.8687C16.5328 12.7046 16.625 12.4821 16.625 12.25C16.625 12.0179 16.5328 11.7954 16.3687 11.6313C16.2046 11.4672 15.9821 11.375 15.75 11.375H8.75Z",
    fill: "#344051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12.25C3.5 7.41738 7.41738 3.5 12.25 3.5C17.0826 3.5 21 7.41738 21 12.25C21.0032 14.269 20.3051 16.2265 19.0251 17.7879L23.8061 22.5689C23.9655 22.7339 24.0537 22.9549 24.0517 23.1844C24.0497 23.4138 23.9577 23.6332 23.7955 23.7955C23.6332 23.9577 23.4138 24.0497 23.1844 24.0517C22.9549 24.0537 22.7339 23.9655 22.5689 23.8061L17.7879 19.0251C16.2265 20.3051 14.269 21.0032 12.25 21C7.41738 21 3.5 17.0826 3.5 12.25ZM12.25 5.25C10.3935 5.25 8.61301 5.9875 7.30025 7.30025C5.9875 8.61301 5.25 10.3935 5.25 12.25C5.25 14.1065 5.9875 15.887 7.30025 17.1997C8.61301 18.5125 10.3935 19.25 12.25 19.25C14.1065 19.25 15.887 18.5125 17.1997 17.1997C18.5125 15.887 19.25 14.1065 19.25 12.25C19.25 10.3935 18.5125 8.61301 17.1997 7.30025C15.887 5.9875 14.1065 5.25 12.25 5.25Z",
    fill: "#344051"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.79d50508e6017df43f70470c95606891.svg";
export { ForwardRef as ReactComponent };